export const STAGE = {
  STAGING: 'staging',
  DEMO: 'demo',
  PRODUCTION: 'production',
}
